// MobileAdverts.js
import React from "react";
import { useGetHomepageAdvertsQuery } from "../../slices/homepageSlice";

const MobileAdverts = () => {
  const { data: adverts } = useGetHomepageAdvertsQuery();

  return (
    <div className="flex space-x-2">
      {adverts?.slice(0, 2).map((advert) => (
        <div
          key={advert._id}
          className="bg-gray-200 w-1/2 rounded-md overflow-hidden shadow-sm"
        >
          <img
            src={advert.image}
            alt={advert.title}
            className="w-full h-full object-cover"
            onClick={() => window.open(advert.url, "_blank")}
          />
        </div>
      ))}
    </div>
  );
};

export default MobileAdverts;
